import script from "./OnlineMentalHealthScreeningView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineMentalHealthScreeningView.vue?vue&type=script&setup=true&lang=js"

import "./OnlineMentalHealthScreeningView.vue?vue&type=style&index=0&id=0eaef31e&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eaef31e"]])

export default __exports__